import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createSimpleUser } from '../user/SimpleUser';
import { UserModel } from '../user/user';

/**
 * # DeptTree
 *
 * DeptTree을 설명하세요.
 */
export const DeptTree: any = types
  .model('DeptTree')
  // --------------------------------------------------------------------------
  .props({
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    deptSid: types.optional(types.number, 0), // 부서 고유 ID
    deptPsid: types.maybeNull(types.optional(types.number, 0)),
    deptNm: types.optional(types.string, ''), // 부서 이름
    deptDescr: types.maybeNull(types.string), // 부서 설명
    ordr: types.maybeNull(types.maybeNull(types.number)), // 부서 순서
    isClickable: types.optional(types.boolean, false), // 부서접근권한
    // delYn: types.boolean, // 삭제 여부
    childDept: types.maybeNull(types.array(types.late(() => DeptTree))), // 자식 부서 (재귀적 모델)
    userList: types.maybeNull(types.array(UserModel)),
    regUser: createSimpleUser(),
    updUser: createSimpleUser(),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model deptTree --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDeptTree;
      (Object.keys(newProps) as TDeptTreeKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDeptTree = Instance<typeof DeptTree>;
type TDeptTreeSnapshot = SnapshotOut<typeof DeptTree>;

export interface IDeptTree extends TDeptTree {}
export type TDeptTreeKeys = keyof TDeptTreeSnapshot & string;
export interface IDeptTreeSnapshot extends TDeptTreeSnapshot {}
export const createDeptTree = () => types.optional(DeptTree, {} as TDeptTree);
